import { Typography } from '@navi/web-ui/lib/primitives';
import styles from './index.module.scss';
import { BannerType } from '../../types';
import CountdownBanner from './CountdownBanner';

interface MockBannerProps {
  bannerType: BannerType;
  message: string | null;
  secondsRemaining: number;
}

const MockBanner = ({ bannerType, message, secondsRemaining }: MockBannerProps) => {
  switch (bannerType) {
    case BannerType.COUNTDOWN:
      return <CountdownBanner message={message} secondsRemaining={secondsRemaining} />;

    case BannerType.BLOCKED:
      return (
        <div className={styles.blockedBanner}>
          <Typography variant="h5" color="white">
            {message}
          </Typography>
        </div>
      );

    case BannerType.WARNING:
      return (
        <div className={styles.warningBanner}>
          <Typography variant="h5" color="var(--light-grayscale-content-2)">
            {message}
          </Typography>
        </div>
      );

    default:
      return null;
  }
};

export default MockBanner;
